import * as React from 'react';



export default class Info extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g className="infoIcon" id="icons/info" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icons/error/white">
          <g>
              <circle id="Oval-7" stroke="" cx="8" cy="8" r="7.5"></circle>
              <text className="infoText" id="i" fontFamily="ProximaNova-Medium, Proxima Nova" fontSize="12" fontWeight="400" fill="">
                  <tspan x="6.602" y="12">i</tspan>
                </text>
          </g>
      </g>
      </g>
      </svg>
    )
  }
}
